import { PackType } from "../PackType";

export const MainAdditional: React.FC<{packType:PackType}> = () => {
    return <div></div>;
}